import {components as reactSelectComponents, GroupBase, InputProps} from 'react-select';

import {suffixTestId} from 'shared/web';

import {useChoice} from '../hooks/choiceContext';

export function ChoiceInput<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: InputProps<Option, IsMulti, Group>
) {
  const context = useChoice();
  return (
    <reactSelectComponents.Input
      data-testid={suffixTestId('choiceInput', context)}
      data-name={context['data-name']}
      {...props}
      // Only Choice sets it, and only Choice has a label it can hide; see
      // `ChoiceContext.isRequired`. Not react-select's own `required`, which
      // also renders a hidden native required input that blocks form submit.
      aria-required={context.isRequired || undefined}
      className={`${props.className} choice-component-input`}
    />
  );
}
